import PipelineMyItemsPage from '../../../components/admin/pipeline/PipelineMyItemsPage'
export default function PipelineMyItems() { return <PipelineMyItemsPage /> }
